import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoIconOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 7,
		cy: 7,
		r: 6.5,
		stroke: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7 10V6H6.25M7 10H8M7 10H6M7 3V4",
		stroke: "currentColor",
		strokeLinecap: "round"
	})]
});
export default SvgInfoIconOutline;
